/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "O Espaço da Amizade",
      "Encontra Novas Amizades com a Bumble For Friends App | Bumble",
      "Descarregar na App Store",
      "Obter no Google Play",
      "Um espaço dedicado à criação de novas amizades",
      "Descobre pessoas perto de ti, prontas para fazer ligações genuínas.",
      "Encontra amigos em todas as fases da vida",
      "Acabaste de chegar ao bairro? Precisas de um novo começo? Tens novos amigos à tua espera!",
      "Um espaço seguro para todos",
      "Boas-vindas. Chegaste a um lugar onde podes ser tu mesmo.",
      "Instalar app",
      "Encontra-te com pessoas com os mesmos interesses!",
      "Junta-te a um novo grupo com o Plans no Bumble for Friends",
      "Tens um convite para aderires ao Plans",
      "O Plans é um novo recurso do Bumble For Friends, no qual podes criar e aderir a encontros em grupo com novos amigos perto de ti.",
      "Gerir Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
